import {RelatedCostForm} from "../../../models/basic/related-cost";
import {toast} from "react-toastify";
import {translate} from "../../../translate/translate";
import {ErrorComponent} from "../../../components/error/error.component";
import {
    Box,
    FormControl,
    FormControlLabel,
    Grid, InputAdornment,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
import {ErrorMessage, Field, Form, Formik, FormikHelpers} from "formik";
import Select from "@mui/material/Select";
import * as React from "react";
import {Client} from "../../../models/basic/client";
import {Project} from "../../../models/basic/project";
import {Category} from "../../../models/basic/category";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import AddProjectAmortizationComponent from "./add-project-amortization";
import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {RelatedCostService} from "../../../services/related-cost-service";
import {AbstractService} from "../../../services/abstract-service";
import {URLS} from "../../../services/app-urls";
import {useEffect} from "react";
import {sortListObj} from "../../../utils/list-utils";
import * as Yup from "yup";
import {enUS, ptBR} from "date-fns/locale";
import {transformCurrency, transformNumber} from "../../../utils/format-number";

const AddInvoiceComponent = (props: any) => {
    const {
        open,
        handleClose,
    } = props;

    const service = new RelatedCostService();
    const serviceClient = new AbstractService<Client>(URLS.CLIENT);
    const serviceProject = new AbstractService<Project>(URLS.PROJECT);
    const serviceCategory = new AbstractService<Category>(URLS.CATEGORY);

    const [dataSourceClient, setDataSourceClient] = React.useState<Client[]>([]);
    const [dataSourceProject, setDataSourceProject] = React.useState<Project[]>([]);
    const [dataSourceCategory, setDataSourceCategory] = React.useState<Category[]>([]);
    const [invalidForm, setInvalidForm] = React.useState(true);
    const [object, setObject] = React.useState(new RelatedCostForm());

    const amortizationType = object.type === 2;

    const locale = translate.language == "pt" ? ptBR : enUS;

    const schema = Yup.object().shape({
        date: Yup.date().min("1900-01-01", "").required(),
        cy: Yup.string().required(),
        invoice: Yup.string().required(),
        description: Yup.string().required()
    });

    useEffect(() => {
        loadClients();
        loadCategories();
    }, []);

    const loadClients = () => {
        serviceClient.readAll().then(response => {
            const sortedData = sortListObj(response.data, "name");
            setDataSourceClient(sortedData);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    }

    const loadProjects = (id_client: any) => {
        serviceProject.readAll({"client": id_client, "active": true}).then(response => {
            const sortedData = sortListObj(response.data, "name");
            setDataSourceProject(sortedData);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    }

    const loadCategories = () => {
        serviceCategory.readAll({"active": true}).then(response => {
            const sortedData = sortListObj(response.data, "name");
            setDataSourceCategory(sortedData);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    }

    const handleSubmit = (values: RelatedCostForm) => {
        setTimeout(() => {
            const relatedCost = new RelatedCostForm();

            Object.assign(relatedCost, values);
            const {formatted_total, ...cleanedRelatedCost} = relatedCost;

            cleanedRelatedCost.client = values.client.id as any;
            cleanedRelatedCost.project = values.project.id as any;
            cleanedRelatedCost.category = values.category.id as any;

            const newObj = {
                ...cleanedRelatedCost,
                date: new Date(values.date!.toString()).toISOString().split("T")[0]
            }

            if (amortizationType) {
                newObj.items = newObj.items.map(({formatted_value, ...rest}) => rest);
            }

            let svc;
            if (amortizationType) {
                svc = service.createAmortization(newObj as any);
            } else {
                svc = service.create(newObj as any);
            }

            svc.then(() => {
                toast.success(translate.t("successfully_registered"));
                setObject(new RelatedCostForm());
                handleCloseDialog(true);
            })
                .catch((error: any) => {
                    ErrorComponent(error);
                });
        }, 500);
    }

    const handleObjChange = (values: RelatedCostForm) => {
        setObject(values);
        checkForm(values);
    }

    useEffect(() => {
        checkForm(object);
    }, [object.type]);

    const checkForm = (row: RelatedCostForm) => {
        setInvalidForm(
          (!!row.errors && row.errors.length > 0) ||
            !row.client.id || row.client.id.toString() === '0' ||
            (!amortizationType && (!row.project.id || row.project.id.toString() === '0')) ||
            !row.category.id || row.category.id.toString() === '0' ||
            !row.date ||
            !row.cy ||
            !row.invoice ||
            !row.description ||
            !row.total ||
            (amortizationType && !isItemsValuesValid(row))
        );
    }


    const isItemsValuesValid = (row: RelatedCostForm) => {
        return row.items.length > 0 && row.items.reduce((acc, item) => acc + item.value, 0) <= row.total;
    }

    const handleCloseDialog = (canSearch?: boolean) => {
        setInvalidForm(true);
        setObject(new RelatedCostForm());
        handleClose(canSearch);
    };

    const setSelectedYear = (date?: string) => {
        const obj = object;
        const year = date ? new Date(date).getFullYear() : 0;
        if (date) {
            handleObjChange({
                ...obj,
                date: date as unknown as Date,
                cy: year || 0,
            });
        }
    }

    return (
        <GenericDialog
            open={open}
            onClose={handleCloseDialog}
            title={"add_invoice"}
            colorButton={"primary"}
            labelButton={"save"}
            disableConfirm={invalidForm}
            handleConfirm={() => handleSubmit(object)}
            maxWidth={"md"}
        >
            <Box>
                <FormControl fullWidth>
                    <Formik
                        id="dialog-form"
                        enableReinitialize
                        initialValues={object}
                        validationSchema={schema}
                        onSubmit={(values: RelatedCostForm, {resetForm}: FormikHelpers<RelatedCostForm>) => {
                            handleSubmit(values);
                            resetForm();
                            handleCloseDialog();
                        }}
                        validateOnChange={true}>
                        {({isValid, values, isValidating, errors, touched}) => (
                            <Form autoComplete="off">
                                <Grid container spacing={2} direction={"column"}>
                                    <Grid >
                                        <RadioGroup row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    onChange={(event) => {
                                                        handleObjChange({
                                                            ...object,
                                                            type: Number(event.target.value),
                                                        });
                                                    }}>
                                            <FormControlLabel value="1" control={<Radio />} label="NRE Costs" checked={object.type === 1}/>
                                            <FormControlLabel value="2" control={<Radio />} label="Amortization" checked={object.type === 2}/>
                                        </RadioGroup>
                                    </Grid>
                                    <Grid >
                                        <Grid container spacing={2} direction={"row"}>
                                            {/* CLIENT */}
                                            <Grid size={amortizationType ? 8 : 4}>
                                                <FormControl fullWidth>
                                                    <InputLabel
                                                        required={true}
                                                        className={
                                                            touched.client && Boolean(errors.client) ? "error-required" : ""
                                                        }
                                                    >
                                                        {translate.t("client")}
                                                    </InputLabel>
                                                    <Field
                                                        as={Select}
                                                        name="client.id"
                                                        label={translate.t("client")}
                                                        variant={"outlined"}
                                                        fullWidth
                                                        autoFocus={true}
                                                        values={values}
                                                        placeholder={translate.t("select_client")}
                                                        error={touched.client && Boolean(errors.client)}
                                                        helperText={<ErrorMessage name="client"/>}
                                                        onChange={(event: React.ChangeEvent<{
                                                            value: number
                                                        }>) => {
                                                            const obj = object;
                                                            const value = event.target.value;
                                                            handleObjChange({
                                                                ...obj,
                                                                client: {
                                                                    ...obj.client,
                                                                    id: value,
                                                                },
                                                            });
                                                            loadProjects(event.target.value);
                                                        }}
                                                        required={true}>
                                                        {dataSourceClient?.map((client: Client) => (
                                                            <MenuItem key={client.id} value={client.id}>
                                                                {client.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    {(touched.client && Boolean(errors.client)) && (
                                                        <div className={"required-field"}>
                                                            {translate.t("required_field")}
                                                        </div>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            {/* PROJECT */}
                                            {!amortizationType && (
                                                <Grid size={4}>
                                                    <FormControl fullWidth>
                                                        <InputLabel
                                                            required={true}
                                                            className={
                                                                touched.project && Boolean(errors.project) ? "error-required" : ""
                                                            }
                                                        >
                                                            {translate.t("project")}
                                                        </InputLabel>
                                                        <Field
                                                            as={Select}
                                                            name="project.id"
                                                            label={translate.t("project")}
                                                            variant={"outlined"}
                                                            fullWidth
                                                            autoFocus={false}
                                                            values={values}
                                                            placeholder={translate.t("select_project")}
                                                            error={touched.project && Boolean(errors.project)}
                                                            helperText={<ErrorMessage name="client"/>}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    style: {
                                                                        maxHeight: '400px',
                                                                    },
                                                                },
                                                            }}
                                                            onChange={(event: React.ChangeEvent<{
                                                                value: number
                                                            }>) => {
                                                                const obj = object;
                                                                const value = event.target.value;
                                                                handleObjChange({
                                                                    ...obj,
                                                                    project: {
                                                                        ...obj.project,
                                                                        id: value,
                                                                    },
                                                                });
                                                            }}
                                                            disabled={object.client.id === 0 || !object.client}
                                                            required={true}>
                                                            {dataSourceProject?.map((project: Project) => (
                                                                <MenuItem key={project.id} value={project.id}>
                                                                    {project.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Field>
                                                        {(touched.project && Boolean(errors.project)) && (
                                                            <div className={"required-field"}>
                                                                {translate.t("required_field")}
                                                            </div>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                            )}
                                            {/* CATEGORY */}
                                            <Grid size={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel
                                                        required={true}
                                                        className={
                                                            touched.category && Boolean(errors.category) ? "error-required" : ""
                                                        }
                                                    >
                                                        {translate.t("category")}
                                                    </InputLabel>
                                                    <Field
                                                        as={Select}
                                                        name="category.id"
                                                        label={translate.t("category")}
                                                        variant={"outlined"}
                                                        fullWidth
                                                        autoFocus={false}
                                                        values={values}
                                                        placeholder={translate.t("select_category")}
                                                        error={touched.category && Boolean(errors.category)}
                                                        helperText={<ErrorMessage name="category"/>}
                                                        onChange={(event: React.ChangeEvent<{
                                                            value: number
                                                        }>) => {
                                                            const obj = object;
                                                            const value = event.target.value;
                                                            handleObjChange({
                                                                ...obj,
                                                                category: {
                                                                    ...obj.category,
                                                                    id: value,
                                                                },
                                                            });
                                                        }}
                                                        required={true}>
                                                        {dataSourceCategory?.map((category: Category) => (
                                                            <MenuItem key={category.id} value={category.id}>
                                                                {category.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Field>
                                                    {(touched.category && Boolean(errors.category)) && (
                                                        <div className={"required-field"}>
                                                            {translate.t("required_field")}
                                                        </div>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid >
                                        <Grid container spacing={2} direction={"row"}>
                                            {/* DATE */}
                                            <Grid >
                                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
                                                    <DatePicker
                                                        name={"date"}
                                                        label={translate.t("date")}
                                                        value={values.date}
                                                        inputRef={(props: any) => (
                                                            <TextField
                                                                {...props}
                                                                required={true}
                                                            />
                                                        )}
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                required: true,
                                                            }
                                                        }}
                                                        onChange={(date: any) => {
                                                            const obj = object;
                                                            handleObjChange({
                                                                ...obj,
                                                                date: date as Date,
                                                            });
                                                            setSelectedYear(date);
                                                        }}
                                                        onError={(error: any, value: any) => {
                                                            if (error) {
                                                                object.errors?.push(error);
                                                            } else {
                                                              object.errors = [];
                                                            }
                                                            checkForm(object);
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            {/* CY */}
                                            <Grid >
                                                <Field
                                                    as={TextField}
                                                    name="cy"
                                                    label={"CY"}
                                                    variant={"outlined"}
                                                    fullWidth
                                                    values={values}
                                                    error={touched.cy && Boolean(errors.cy) && invalidForm}
                                                    onChange={(event: React.ChangeEvent<{
                                                        value: unknown
                                                    }>) => {
                                                        const obj = object;
                                                        const value = event.target.value as number;
                                                        handleObjChange({
                                                            ...obj,
                                                            cy: value as number,
                                                        });
                                                    }}
                                                    disabled={true}
                                                />
                                            </Grid>
                                            {/* INVOICE */}
                                            <Grid >
                                                <Field
                                                    as={TextField}
                                                    name="invoice"
                                                    label={translate.t("invoice_code")}
                                                    variant={"outlined"}
                                                    fullWidth
                                                    autoFocus={false}
                                                    required={true}
                                                    values={values}
                                                    error={touched.invoice && Boolean(errors.invoice) && invalidForm}
                                                    onChange={(event: React.ChangeEvent<{
                                                        value: unknown
                                                    }>) => {
                                                        if (event.target.value && event.target.value.toString().length > 15) {
                                                            return;
                                                        }
                                                        const obj = object;
                                                        const value = event.target.value as string;
                                                        handleObjChange({
                                                            ...obj,
                                                            invoice: value as string,
                                                        });
                                                    }}
                                                    InputProps={{
                                                        maxLength: 15,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {touched.invoice && Boolean(errors.invoice) && invalidForm && (
                                                                    <div className={"required-field"}>
                                                                        {translate.t("required_field")}
                                                                    </div>
                                                                )}
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid >
                                        <Grid container spacing={2} direction={"row"}>
                                            {/* DESCRIPTION */}
                                            <Grid size={8}>
                                                <Field
                                                    as={TextField}
                                                    name="description"
                                                    label={translate.t("partnumber_desc")}
                                                    variant={"outlined"}
                                                    fullWidth
                                                    autoFocus={false}
                                                    required={true}
                                                    values={values}
                                                    error={touched.description && Boolean(errors.description) && invalidForm}
                                                    onChange={(event: React.ChangeEvent<{
                                                        value: unknown
                                                    }>) => {
                                                        if (event.target.value && event.target.value.toString().length > 255) {
                                                            return;
                                                        }
                                                        const obj = object;
                                                        const value = event.target.value as string;
                                                        handleObjChange({
                                                            ...obj,
                                                            description: value as string,
                                                        });
                                                    }}
                                                    InputProps={{
                                                        maxLength: 54,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {touched.description && Boolean(errors.description) && invalidForm && (
                                                                    <div className={"required-field"}>
                                                                        {translate.t("required_field")}
                                                                    </div>
                                                                )}
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            {/* INVOICE VALUE */}
                                            <Grid >
                                                <Field
                                                    as={TextField}
                                                    name="formatted_total"
                                                    label={translate.t("invoice_value")}
                                                    variant={"outlined"}
                                                    fullWidth
                                                    autoFocus={false}
                                                    required={true}
                                                    values={values}
                                                    error={touched.total && Boolean(errors.total) && invalidForm}
                                                    onChange={(event: React.ChangeEvent<{
                                                        value: string
                                                    }>) => {
                                                        const obj = object;
                                                        let rawValue = event.target.value;
                                                        let numericValue = transformNumber(rawValue);
                                                        handleObjChange({
                                                            ...obj,
                                                            total: numericValue,
                                                            formatted_total: transformCurrency(numericValue),
                                                        });
                                                    }}
                                                    InputProps={{
                                                        maxLength: 54,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {touched.total && Boolean(errors.total) && invalidForm && (
                                                                    <div className={"required-field"}>
                                                                        {translate.t("required_field")}
                                                                    </div>
                                                                )}
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {amortizationType && (
                                        <Grid >
                                            <AddProjectAmortizationComponent
                                                changeList={(list: any) => {
                                                    const obj = object;
                                                    handleObjChange({
                                                        ...obj,
                                                        items: list,
                                                    });
                                                }}
                                                invoiceValue={object.total}
                                                id_client={object.client.id}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </FormControl>
            </Box>
        </GenericDialog>
    )
}

export default AddInvoiceComponent;
